module.exports = __webpack_public_path__ + "img/lineup35@2x.dda90fab.png";